import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    centered: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    header: {
      padding: 20,
      paddingBottom: 12,
      borderBottomWidth: 1,
    },
    searchContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      borderRadius: 10,
      paddingHorizontal: 12,
    },
    searchInput: {
      flex: 1,
      paddingVertical: 12,
      fontSize: 16,
    },
    listContent: {
      paddingHorizontal: 16,
      paddingTop: 12,
      paddingBottom: 20,
    },
    emptyList: {
      flexGrow: 1,
    },
    card: {
      borderRadius: 12,
      padding: 16,
      marginBottom: 12,
      borderWidth: 1,
      gap: 8,
    },
    cardHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    logoCircle: {
      width: 36,
      height: 36,
      borderRadius: 18,
      borderWidth: 1,
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      flexShrink: 0,
    },
    logoImage: {
      width: 36,
      height: 36,
      borderRadius: 18,
    },
    cardName: {
      fontSize: 17,
      fontWeight: '600',
      flex: 1,
    },
    cardDescription: {
      fontSize: 13,
    },
    cardFooter: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
    },
    cardFooterText: {
      fontSize: 12,
      flex: 1,
    },
    empty: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 100,
    },
    emptyText: {
      fontSize: 20,
      fontWeight: '600',
      marginBottom: 8,
    },
    emptySub: {
      fontSize: 14,
    },
    footer: {
      padding: 20,
      alignItems: 'center',
    },
  });
